import Page from "../../components/work/layout/Page";
import UserGroups from "../../components/work/users/UserGroups";
import Users from "../../components/work/users/Users";

const UsersAndUserGroups: React.FC = () => {
  return (
    <Page pageTitle="Users" breadcrumbs={[{ linkName: "Users", linkUlr: "" }]}>
      <section className="section">
        {/* <!-- Tabs Navigation --> */}
        <div className="card p-2">
          {/* <!-- Tabs Definition --> */}
          <div className="card-header p-0 border-0">
            <ul className="nav nav-tabs profile-tabs">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#users"
                >
                  Users
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#user-groups"
                >
                  User Groups
                </button>
              </li>
            </ul>
          </div>

          {/* <!-- Tabs Content --> */}
          <div className="card-body">
            <div className="tab-content">
              <div className="tab-pane fade active show" id="users">
                <Users />
              </div>
            </div>

            <div className="tab-content">
              <div className="tab-pane fade" id="user-groups">
                <UserGroups />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default UsersAndUserGroups;
